// ============================================================
// Teslim imzasının saklanması (§4)
//
// İki mod, fotoğraflarla aynı ayrım:
//   gerçek mod → Storage'a yüklenir, kayda YOL yazılır
//   demo mod   → data URL doğrudan kayda gömülür
//
// Demoda gömmek bilinçli: satış sunumunda imzanın ekranda görünmesi
// gerekiyor ve Firebase yok. İmza PNG'si birkaç KB, mutasyon günlüğü
// localStorage'da — demo hacminde sorun değil. Gerçek modda ASLA
// gömülmez; orada imza Storage'da durur ve kayıtta yalnızca yolu olur.
// ============================================================

import { firebaseHazir } from "../config.js";

/**
 * @returns {Promise<{path?: string, dataUrl?: string}>}
 */
export async function imzayiSakla(tenantId, branchId, gun, studentId, dataUrl) {
  if (!firebaseHazir) return { dataUrl };

  const { imzaYukle } = await import("./storage-dosyalar.js");
  return { path: await imzaYukle(tenantId, branchId, gun, studentId, dataUrl) };
}

/**
 * Kayıttaki imzayı görüntülenebilir hâle getirir.
 * Demoda data URL zaten kayıtta; gerçek modda yol çözülür.
 */
export async function imzayiCoz(kayit) {
  if (kayit?.outSignatureDataUrl) return kayit.outSignatureDataUrl;
  if (!kayit?.outSignaturePath) return null;

  const { imzaUrl } = await import("./storage-dosyalar.js");
  return imzaUrl(kayit.outSignaturePath);
}

/** Kayıtta imza var mı? Görüntülemeden, senkron. */
export const imzaliMi = (kayit) =>
  Boolean(kayit?.outSignaturePath || kayit?.outSignatureDataUrl);
